<template>
  <v-card elevation="0">
    <v-card-title class="pa-0">
      <v-row align="center" justify="center" class="w-100">
        <!-- Center Title and ID -->
        <v-col cols="12" class="caption text-center">
          Applicant Registration Form -
          <strong>{{ form.applicant.application_id }}</strong>
        </v-col>

        <v-col
          cols="12"
          v-if="pendingReasons.length"
          class="d-flex justify-end mt-n12 mr-4 pb-6"
        >
          <v-btn @click="dialog = true" small text class="primary--text"
            >View Pending Reasons</v-btn
          >
        </v-col>
      </v-row>
    </v-card-title>

    <v-tabs
      v-model="activeTab"
      background-color="primary"
      show-arrows
      mobile-breakpoint="600"
      grow
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <!-- next-icon="mdi-arrow-right-bold-box-outline"
        prev-icon="mdi-arrow-left-bold-box-outline" -->
      <v-tab active-class="accent">Applicant Details</v-tab>
      <v-tab
        active-class="accent"
        :disabled="
          (activeTab === 0 && !isDetailsValid) ||
          (!isDetailsValid && form.applicant.step < 1)
        "
        >Address
      </v-tab>
      <v-tab
        active-class="accent"
        :disabled="
          (activeTab === 0 && !isDetailsValid) ||
          (activeTab === 1 && !isAddressValid) ||
          (!isAddressValid && form.applicant.step < 2)
        "
        >Education Details
      </v-tab>

      <v-tab
        active-class="accent"
        :disabled="
          (activeTab === 0 && !isDetailsValid) ||
          (activeTab === 1 && !isAddressValid) ||
          (activeTab === 2 && !isEducationValid) ||
          (!isEducationValid && form.applicant.step < 3)
        "
        >Declaration & Preview
      </v-tab>
    </v-tabs>

    <v-card-text class="pa-0">
      <v-tabs-items v-model="activeTab" touchless>
        <v-tab-item>
          <ApplicantDetails
            :value="form.applicant"
            @validate="validateTab($event, 'applicant')"
            @submit="handleApplicantDetailsSubmit"
            :isReadOnly="isReadOnly"
            :submitLoading="applicantSubmitLoading"
          />
        </v-tab-item>

        <v-tab-item>
          <AddressDetails
            :value="form.address"
            :allForm="form.applicant"
            @validate="validateTab($event, 'address')"
            @submit="handleAddressDetailsSubmit"
            :isReadOnly="isReadOnly"
            :submitLoading="addressSubmitLoading"
          />
        </v-tab-item>

        <v-tab-item>
          <EducationDetails
            :value="form.education"
            :allForm="form.applicant"
            @input="(newEducation) => (form.education = newEducation)"
            @validate="validateTab($event, 'education')"
            @submit="handleEducationDetailsSubmit"
            :isReadOnly="isReadOnly"
            :submitLoading="educationSubmitLoading"
          />
        </v-tab-item>

        <v-tab-item>
          <DeclarationDetails
            :value="form"
            @submit="handleDeclarationDetailsSubmit"
            :isReadOnly="isReadOnly"
            :submitLoading="declarationSubmitLoading"
          />
        </v-tab-item>
      </v-tabs-items>
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title class="subtitle-1 primary white--text"
            >Pending Reasons</v-card-title
          >
          <v-card-text>
            <v-timeline dense small>
              <v-timeline-item
                v-for="(r, i) in pendingReasons"
                :key="i"
                :color="r.status === 'Open' ? 'orange' : 'green'"
                small
                :icon="r.icon"
                fill-dot
              >
                <div class="mb-2 subtitle-2">
                  {{ r.user }} <small>({{ r.inserted_at }}) </small>
                  <br />
                  <span class="caption">{{ r.text }}</span>
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small color="primary" @click="dialog = false"
              >close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import ApplicantDetails from "@/components/ApplicantDetails.vue";
import AddressDetails from "@/components/AddressDetails.vue";
import EducationDetails from "@/components/EducationDetails.vue";
import DeclarationDetails from "@/components/DeclarationDetails.vue";
import { applicantPayload } from "@/helpers/payload";
import { cloneDeep } from "lodash";

export default {
  components: {
    ApplicantDetails,
    AddressDetails,
    EducationDetails,
    DeclarationDetails,
  },
  data() {
    return {
      activeTab: 0,
      form: {
        applicant: {
          family: {},
          step: 1,
        },
        address: {},
        education: [],
      },
      validation: {
        applicant: false,
        address: false,
        education: false,
      },
      applicantSubmitLoading: false,
      addressSubmitLoading: false,
      educationSubmitLoading: false,
      declarationSubmitLoading: false,
      applicationId: null,
      debId: null,
      dob: null,
      applicantId: null,
      qualifications: [],
      isReadOnly: false,
      pendingReasons: [],
      dialog: false,
    };
  },
  watch: {
    activeTab() {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: "instant" }); // Smooth scrolling
      });
    },
  },
  computed: {
    isDetailsValid() {
      return this.validation.applicant;
    },
    isAddressValid() {
      return this.validation.address;
    },
    isEducationValid() {
      return this.validation.education;
    },
  },
  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get("order_id");
    const status = urlParams.get("status");

    this.form = applicantPayload([], this.form);
    this.applicationId = localStorage.getItem("applicationId");
    this.debId = localStorage.getItem("debId");
    this.dob = localStorage.getItem("dob");
    this.applicantId = localStorage.getItem("applicantId");

    this.checkApplicationPenditionReasons();
    await this.applicantInit();
    if (status && orderId) {
      this.activeTab = 3;
      return;
    }
  },
  methods: {
    async checkApplicationPenditionReasons() {
      const applicantId = JSON.parse(localStorage.getItem("applicantId"));
      if (!applicantId) return;
      const reasons = await this.$axios.get(
        `/get_pending_reason_by_applicant/${applicantId}`,
      );
      this.pendingReasons = reasons.data.data
        .flatMap((reasonObj, index, arr) => {
          const isLast = index === arr.length - 1;
          const status = isLast ? "Open" : "Submitted";
          const insertedAgo = this.getTimeAgo(reasonObj.inserted_at);
          const icon = isLast ? "mdi-alert" : "mdi-check";

          return reasonObj.reason.split("\n").map((text) => ({
            user: reasonObj.user.name,
            inserted_at: insertedAgo,
            text,
            status,
            icon: icon,
          }));
        })
        .reverse();

      if (this.pendingReasons.length > 0) {
        this.dialog = true;
      }
    },
    getTimeAgo(dateStr) {
      const [date, time] = dateStr.split(" ");
      const [day, month, year] = date.split("-").map(Number);
      const [hours, minutes, seconds] = time.split(":").map(Number);

      const insertedAt = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        seconds,
      );
      const now = new Date();

      const diffMs = now - insertedAt;
      const diffSec = Math.floor(diffMs / 1000);
      const diffMin = Math.floor(diffSec / 60);
      const diffHr = Math.floor(diffMin / 60);
      const diffDay = Math.floor(diffHr / 24);

      if (diffSec < 60)
        return `${diffSec} second${diffSec === 1 ? "" : "s"} ago`;
      if (diffMin < 60)
        return `${diffMin} minute${diffMin === 1 ? "" : "s"} ago`;
      if (diffHr < 24) return `${diffHr} hour${diffHr === 1 ? "" : "s"} ago`;
      return `${diffDay} day${diffDay === 1 ? "" : "s"} ago`;
    },
    async applicantInit() {
      try {
        const response = await this.$axios.get(
          `/applicant_validate/${this.debId}/${this.dob}/${this.applicationId}`,
        );

        const program = await this.$axios.get(
          `/programs/${response.data.data.program_id}`,
        );
        this.qualifications = program.data.data.qualifications;
        this.form = applicantPayload(this.qualifications, response.data.data);

        this.isReadOnly =
          this.form.applicant?.application_status != "Draft" &&
          this.form.applicant?.application_status != "Provisionally Approved" &&
          this.form.applicant?.application_status != "Pending";
      } catch (error) {
        const errorMessage = await this.$store.dispatch(
          "throwError",
          error.response,
        );
        this.$store.commit("showSnackbar", {
          message: errorMessage,
          color: "error",
        });
        this.$router.push("/");
      }
    },
    validateTab(event, tab) {
      this.validation[tab] = event;
    },
    async updateApplicant(id, formData) {
      try {
        // Send via Axios or Fetch
        const response = await this.$axios.put(
          `/update_applicant/${id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );
        return response;
      } catch (error) {
        const errorMessage = await this.$store.dispatch(
          "throwError",
          error.response,
        );
        throw errorMessage;
      }
    },
    async handleApplicantDetailsSubmit(applicantFormData) {
      try {
        const formData = new FormData();
        const applicantData = cloneDeep(applicantFormData);

        // Extract file fields
        const fileFields = [
          { id: "aadharImage", key: "aadhar" },
          { id: "panImage", key: "pan" },
          { id: "photoImage", key: "photo" },
        ];
        fileFields.forEach((item) => {
          if (applicantData[item.id] instanceof File) {
            formData.append(
              item.key,
              applicantData[item.id],
              applicantData[item.id].name,
            );
          }
          delete applicantData[item.id]; // Remove from object to avoid duplication
          delete applicantData[item.key]; // Remove from object to avoid duplication
        });
        applicantData.step = applicantData.step > 1 ? applicantData.step : 1;

        // Append JSON object
        formData.append("attrs", JSON.stringify(applicantData));

        let response = null;
        response = await this.updateApplicant(this.applicantId, formData);

        this.form = applicantPayload(this.qualifications, response.data.data);
        this.activeTab = 1;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error,
          color: "error",
        });
      } finally {
        this.applicantSubmitLoading = false;
      }
    },
    async handleAddressDetailsSubmit(addressFormData) {
      try {
        const formData = new FormData();
        let step = this.form.applicant.step > 2 ? this.form.applicant.step : 2;

        // Append JSON object
        formData.append("attrs", JSON.stringify({ ...addressFormData, step }));

        const response = await this.updateApplicant(this.applicantId, formData);

        this.form = applicantPayload(this.qualifications, response.data.data);
        this.activeTab = 2;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error,
          color: "error",
        });
      } finally {
        this.addressSubmitLoading = false;
      }
    },
    async handleEducationDetailsSubmit(educationFormData, applicantMap) {
      try {
        const formData = new FormData();
        const fileFields = [
          { id: "idCard", key: "id_card" },
          { id: "employmentLetter", key: "employment_letter" },
          { id: "kovidaCertificate", key: "kovida_certificate" },
        ];
        fileFields.forEach((item) => {
          if (applicantMap[item.id] instanceof File) {
            formData.append(
              item.key,
              applicantMap[item.id],
              applicantMap[item.id].name,
            );
          }
          delete applicantMap[item.id];
          delete applicantMap[item.key];
        });

        // Clone education data to avoid modifying original
        const filteredEducationData = educationFormData.map((item) => {
          const { upload_image, upload_certificate, ...rest } = item; // Extract file fields
          if (upload_image instanceof File) {
            formData.append(
              item.qualification_id,
              upload_image,
              upload_image.name,
            );
          }
          if (upload_certificate instanceof File) {
            formData.append(
              item.qualification_id + "_certificate",
              upload_certificate,
              upload_certificate.name,
            );
          }
          return rest;
        });

        let map = { ...applicantMap };
        map.education = filteredEducationData;
        map.step = this.form.applicant.step > 3 ? this.form.applicant.step : 3;

        // Append JSON object
        formData.append("attrs", JSON.stringify(map));

        const response = await this.updateApplicant(this.applicantId, formData);

        this.form = applicantPayload(this.qualifications, response.data.data);

        this.activeTab = 3;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error,
          color: "error",
        });
      } finally {
        this.educationSubmitLoading = false;
      }
    },
    async handleDeclarationDetailsSubmit(sp_acceptance = false) {
      this.declarationSubmitLoading = true;
      try {
        const formData = new FormData();
        let application_status =
          this.form?.applicant?.application_status == "Draft"
            ? "Submitted"
            : this.form.applicant.application_status == "Pending"
            ? "Re-Submitted"
            : this.form.applicant.application_status;
        let completion_status =
          this.form?.applicant?.completion_status !== "Awaiting Result"
            ? "Completed"
            : this.form.applicant.completion_status;

        formData.append(
          "attrs",
          JSON.stringify({
            agree: true,
            step: 4,
            application_status,
            completion_status,
            form_submit: true,
            sp_acceptance,
          }),
        );

        await this.updateApplicant(this.applicantId, formData);

        this.$router.push("/success");
      } catch (error) {
        this.$store.commit("showSnackbar", { message: error, color: "error" });
      } finally {
        this.declarationSubmitLoading = false;
      }
    },
  },
};
</script>

<style scoped></style>
